<template>
  <header>
    <div class="mb-header">
      <div class="header-wrap">
        <div class="header-panel">
          <div class="header-auth" v-if="isAuthReady">
            <div class="header-auth-item">
              <a
                v-if="isAuthorized && isUserFetched"
                href="/logout"
                @click.prevent="logout"
                class="header-auth-link"
                v-t="'header.auth.logout'"/>
              <template v-else-if="isAuthorized"/>
              <a
                v-else
                href="https://t.me/MeetBot?start=login"
                target="_blank"
                class="header-auth-link"
                v-t="'header.auth.login'"/>
            </div>
            <div
              v-if="isAuthorized && isUserFetched"
              class="header-auth-item header-user-item">
                <router-link class="header-auth-photo" :to="'/id' + authUser.id">
                  <avatar :user="authUser" class="header-avatar"/>
                </router-link>
            </div>
          </div>

          <div class="header-breadcrumb header-breadcrumb-simple">
            <ol id="breadcrumb" class="header-nav breadcrumb">
              <li class="mb-logo">
                <router-link to="/">
                  <i class="mb-icon"/>
                  <span class="mb-logo-title">Meet</span>
                </router-link>
              </li>
            </ol>
          </div>

        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import Avatar from '@/components/core/Avatar.vue'

  import {
    isAuthReady,
    isAuthorized,
    authUser,
    logout,
  } from '@/mixins/auth'

  export default {
    name: 'Header',
    mixins: [
      isAuthReady,
      isAuthorized,
      authUser,
      logout,
    ],
    components: {
      Avatar,
    }
  }
</script>

<style scoped lang="stylus">
  header
    width 100%
    margin 0
    top 0
    position fixed
    z-index 100
    background #fff

  .mb-header
    max-width 510px
    margin 0 auto

  .header-wrap
    padding 9px 0 8px
    position relative
    background #fff
    box-shadow 0 1px rgba(0, 0, 0, .12)
    z-index 2
    font-size 15px

  .header-panel
    position relative
    padding 0 15px
    z-index 7

  .mb-logo
    height 41px
    overflow hidden
    display flex
    flex-direction row
    align-items center

  .header-auth
    float right
    margin-left 15px

  .header-auth-item
    display inline-block
    vertical-align top
    padding 11px 0
    font-weight 500
    white-space nowrap
    line-height 1.3

    .header-auth-photo
      display inline-block
      vertical-align top
      margin -7px 0 -7px 0

      .header-avatar
        width 32px
        height 32px
        line-height 33px
        font-size 13px

  .header-auth-item + .header-auth-item
    margin-left 15px

</style>

<style scoped>
  header.has-search + main section.cd-content {
    padding-top: 49px;
  }
  header.has-message + main {
    margin-top: 112px;
  }
  header .btn-lg {
    padding: 11px 12px 10px;
  }
  .header-auth-link {
    display: inline-block;
    vertical-align: top;
  }
  .header-search-item {
    padding-bottom: 18px;
    margin-bottom: -18px;
    overflow: hidden;
  }
  .header-auth-name {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 190px;
    color: #0086d3;
  }
  .header-auth-name.dropdown-toggle {
    cursor: pointer;
  }
  .header-auth-name + .dropdown-menu {
    top: -21px;
    left: auto;
    right: -4px;
  }
  @media (min-width: 1420px) {
    .header-auth-name + .dropdown-menu {
      left: -4px;
      right: auto;
    }
  }

  .header-message {
    background: #1e98d4;
    text-align: center;
    color: #fff;
    padding: 13px 15px;
  }
  .header-message a {
    color: #fff;
    text-decoration: underline;
  }
  .header-message .hide-button {
    color: #fff;
    margin: -11px -12px -10px 12px;
    font-weight: normal;
    float: right;
  }

  header .breadcrumb > .active,
  header .breadcrumb > .active a {
    color: #222;
  }
  header .breadcrumb > .placeholder {
    color: #999;
  }
  header .breadcrumb > li {
    padding: 11px 0;
    font-size: 15px;
    line-height: 1.3333333;
    font-weight: 500;
    position: relative;
  }
  header .breadcrumb > li > a,
  header .breadcrumb > li.active > strong {
    display: inline-block;
    text-overflow: ellipsis;
    vertical-align: top;
    overflow: hidden;
    max-width: 190px;
  }
  header .container-fluid .breadcrumb > li > a,
  header .container-fluid .breadcrumb > li.active > strong {
    max-width: 240px;
  }
  header .breadcrumb > li.active > a {
    overflow: visible;
    max-width: none;
  }
  header .breadcrumb > li:before {
    content: '';
  }
  header .breadcrumb > li:after {
    content: "\00a0/\00a0";
    padding: 0 8px;
    color: #d4d4d4;
  }
  header .breadcrumb > li:last-child:after {
    content: '';
  }
  header .input-group-addon.breadcrumb > li:last-child:after {
    content: "\00a0/\00a0";
  }
  header .header-breadcrumb .dropdown {
    position: static;
  }
  header .header-breadcrumb .dropdown-menu {
    left: auto;
    top: 48px;
    margin: 0 0 0 -15px;
    min-width: 0;
    font-size: 15px;
    border: none;
    box-shadow: 0 0 2px rgba(0, 0, 0, .15);
  }
  header .header-breadcrumb .dropdown.open > .dropdown-menu {
    display: inline;
  }
  header .header-breadcrumb .dropdown.open > .dropdown-menu > li {
    display: block;
  }
  header .header-breadcrumb .dropdown.open > .dropdown-menu > li > a {
    padding: 10px 35px 10px 15px;
    margin: 0;
    color: #2e87ca;
  }
  header .header-breadcrumb .dropdown.open > .dropdown-menu > li > a:hover {
    background-color: #f0f6fa;
    color: #2e87ca;
  }
  header .header-breadcrumb .dropdown.open > .dropdown-menu > li.active > a:hover,
  header .header-breadcrumb .dropdown.open > .dropdown-menu > li.active > a {
    background-color: #1e98d4;
    color: #fff;
    font-weight: 500;
    position: relative;
  }
  header .btn {
    margin-left: 10px;
    margin-right: -12px;
  }
  .buttons-wrap {
    padding: 15px 0;
  }
  .buttons-wrap .btn {
    margin-left: -15px;
  }

  .header-breadcrumb .breadcrumb {
    background: none;
    border: transparent;
    padding: 0;
    margin: 0;
    overflow: visible;
  }
  .header-breadcrumb-simple .breadcrumb {
    overflow: hidden;
  }
  .header-breadcrumb-simple .breadcrumb > .active {
    display: inline;
  }
  .header-breadcrumb .input-label {
    font-weight: normal;
  }
  .input-group .input-dropdown {
    display: table-cell;
    position: relative;
  }
  .input-dropdown .form-control {
    height: auto;
    border: transparent;
    background: transparent;
    color: #222;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 11px 16px 11px 1px;
    margin-left: -1px;
    border-radius: 0 !important;
    transition: color .2s ease;
  }
  .form-control::-webkit-input-placeholder {
    transition: color .2s ease;
    color: #999;
  }
  .form-control::-moz-placeholder {
    transition: color .2s ease;
    color: #999;
  }
  .form-control:-ms-input-placeholder {
    transition: color .2s ease;
    color: #999;
  }
  .form-control:focus::-webkit-input-placeholder {
    color: #ccc;
  }
  .form-control:focus::-moz-placeholder {
    color: #ccc;
  }
  .form-control:focus:-ms-input-placeholder {
    color: #ccc;
  }
  .has-section-status .input-dropdown .form-control {
    padding-right: 50px;
  }
  .cd-header,
  .cd-markdown h3,
  .cd-markdown h4 {
    font-size: 13px;
    line-height: 17px;
    font-weight: bold;
    padding: 2px 0;
    margin: 25px 0 7px;
    text-transform: uppercase;
  }
  .cd-markdown h5,
  .cd-markdown h6 {
    font-size: 14px;
    line-height: 21px;
    font-weight: 500;
    padding: 0;
    margin: 15px 0 4px;
  }
  .mb-icon {
    display: inline-block;
    vertical-align: text-top;
    width: 22px;
    height: 18px;
    background-image: url('data:image/svg+xml,%3C%3Fxml version="1.0" encoding="UTF-8"%3F%3E%3Csvg width="22px" height="19px" viewBox="0 0 22 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"%3E%3Cg id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"%3E%3Cg id="Avatar-2" fill="%235699CD"%3E%3Cg id="users"%3E%3Cpath d="M14.2983988,14.8162 L10.9680091,13.1663091 C10.6539003,13.0105091 10.4586718,12.6975273 10.4586718,12.3493091 L10.4586718,11.1813273 C10.5385063,11.0846 10.6225243,10.9744 10.7093313,10.8528 C11.1412744,10.2482545 11.4874564,9.57530909 11.7391618,8.84950909 C12.231068,8.626 12.5504061,8.14409091 12.5504061,7.6 L12.5504061,6.21818182 C12.5504061,5.88550909 12.4249021,5.5632 12.2017837,5.31136364 L12.2017837,3.47389091 C12.2213066,3.28389091 12.2980035,2.15287273 11.4724657,1.2198 C10.7563953,0.4104 9.59443685,0 8.01831502,0 C6.44219318,0 5.28023475,0.4104 4.56416436,1.21945455 C3.73862653,2.15252727 3.81532346,3.28389091 3.83484631,3.47354545 L3.83484631,5.31101818 C3.61172798,5.56285455 3.48622392,5.88516364 3.48622392,6.21783636 L3.48622392,7.59965455 C3.48622392,8.02007273 3.6790121,8.41216364 4.00811164,8.67367273 C4.32744975,9.92663636 4.99575888,10.8707636 5.22933588,11.1737273 L5.22933588,12.3168364 C5.22933588,12.6512364 5.04526326,12.958 4.74928285,13.1182909 L1.63922249,14.7992727 C0.627868928,15.3464727 0,16.3945818 0,17.5359636 L0,19 L16.03663,19 L16.03663,17.6033273 C16.03663,16.4153091 15.3704126,15.3475091 14.2983988,14.8162 Z" id="Path"%3E%3C/path%3E%3Cpath d="M20.4170476,15.2129109 L17.0217143,13.7600546 C16.9413968,13.7203685 16.8523492,13.6233964 16.775873,13.4939852 L19.0544444,13.4922597 C19.0544444,13.4922597 19.1860952,13.5050283 19.390381,13.5050283 C19.7650794,13.5050283 20.3115873,13.4629265 20.7872063,13.2610451 C21.0725079,13.1395711 21.2848254,12.899729 21.3700317,12.602946 C21.4559365,12.3034023 21.4014603,11.9862586 21.2212698,11.7322675 C20.57,10.8163814 19.0499048,8.42313713 19.0024127,5.9957283 C19.0013651,5.95397162 18.8637778,1.82592719 14.7386032,1.79245283 C14.3240952,1.7959038 13.9322857,1.84628789 13.5610794,1.93497769 C13.8376508,2.65760978 13.8121587,3.30432063 13.7933016,3.51413931 L13.7933016,5.14748108 C14.0195873,5.46566006 14.1425079,5.84354074 14.1425079,6.23142921 L14.1425079,7.61181524 C14.1425079,8.26991428 13.7919048,8.87900962 13.232127,9.22065516 C12.9709206,9.9184403 12.6252063,10.5703276 12.2023175,11.1604426 C12.1499365,11.2339482 12.098254,11.3033126 12.047619,11.3688809 L12.047619,12.3558569 C12.047619,12.5083896 12.1300317,12.6405616 12.2679683,12.7085456 L15.6039365,14.3567265 C16.8565397,14.9758296 17.6345714,16.2199025 17.6345714,17.6040846 L17.6345714,19 L22,19 L22,17.7241782 C22,16.6571398 21.4000635,15.6984617 20.4170476,15.2129109 Z" id="Path"%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E');
  }
  .mb-logo-title {
    /*display: none;*/
    margin-left: 15px;
  }
  li.cd-logo:last-child .cd-logo-title {
    display: inline;
  }
</style>
